import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';

import {Product} from '../models/product';
import {ProductDialogComponent} from './dialogs/product-dialog/product-dialog.component';
import {ProductService} from '../services/product.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: [ './product.component.scss' ],
  entryComponents: [
    ProductDialogComponent
  ]
})
export class ProductComponent implements OnInit {

  @ViewChild('activeSort', {read: MatSort, static: true}) activeSort: MatSort;
  @ViewChild('historySort', {read: MatSort, static: true}) historySort: MatSort;

  public displayedColumns: string[] = [ 'icon', 'created', 'name', 'edit', 'delete' ];

  constructor (
    public _productService: ProductService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService) { }

  ngOnInit () {
  }

  ngAfterViewInit () {
    this._productService.loadProducts(this.activeSort, this.historySort)
  }

  ngOnDestroy () {

  }

  applyFilter (filterValue: string) {
    this._productService.productDataSource.filter = filterValue.trim().toLowerCase();
    // if (this._productService.productDataSource.paginator) {
    //  this._productService.productDataSource.paginator.firstPage();
    // }
  }

  openDialog (entity) {

    let data: Product = new Product();

    if (entity) {
      data = entity;
    }

    this.dialog.open(ProductDialogComponent, {
      width: '990px',
      height: '680px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  delete (element, flag) {
    let word: string
    if (flag) {
      word = "EXCLUIR"
    } else {
      word = "RESTAURAR"
    }
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>" + word + " este produto?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      
      if (result == "ok") {

        this._productService.delete(element.id, flag)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete product error: " + error.message)}
          )

      }
    })
  }

}
